import { render, staticRenderFns } from "./WorkCenterList.vue?vue&type=template&id=b1afb688&"
import script from "./WorkCenterList.vue?vue&type=script&lang=js&"
export * from "./WorkCenterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports